(function () {
    if (window.__msCartExtras) return;
    window.__msCartExtras = true;
    document.addEventListener('click', async function (e) {
      var nav = e.target.closest('[data-ms-nav]');
      if (nav) {
        var track = nav.parentElement.querySelector('.ms-upsell__track');
        track.scrollBy({ left: track.clientWidth * Number(nav.dataset.msNav), behavior: 'smooth' });
        return;
      }
      var btn = e.target.closest('[data-ms-add]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.msAdd), quantity: 1 }] })
        });
        var res = await fetch(window.location.pathname + '?sections=cart-drawer-section');
        var data = await res.json();
        var html = new DOMParser().parseFromString(data['cart-drawer-section'], 'text/html');
        var fresh = html.querySelector('.cart-drawer__inner');
        var current = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (el) { el.textContent = cart.item_count; });
      } catch (err) {
        window.location.href = '/cart';
      } finally {
        btn.disabled = false;
      }
    });
  })();
